//React
import React from 'react';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myPostAction from '../action/myPostAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Fab from '@material-ui/core/Fab';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CropIcon from '@material-ui/icons/Crop';
//Part
import PartDropZone from './PartDropZone';
import PartImageUploadHelp from './PartImageUploadHelp';
//Dialog
import DialogImageCrop from './DialogImageCrop';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      originImage: null,
      uploadThumb: null,
      postId: null,
      dialogImageCropVisible: false,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.originImage !== this.state.originImage && this.state.originImage) {
      this._imageLoad(this.state.originImage);
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 1200).then((res) => {
      this.setState({uploadThumb:res.uri});
    }).catch((err) => {
      this.setState({uploadThumb:null});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(rotate) {
    let file = this.state.uploadThumb;
    await imageRotate(file, rotate).then((res) => {
      this.setState({uploadThumb:res.uri});
    })
  }

  _uploadSubmit() {
    let imageBase64 = this.state.uploadThumb;
    this.props.submit(imageBase64);
    this.setState({uploadThumb:null});
    this.props.close();
  }


	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            写真の登録
          </div>
          <IconButton
            onClick={ () => {
              this.props.close();
              this.setState({uploadThumb: null});
            }}
          >
            <CloseIcon/>
          </IconButton>
        </div>

        <div>
          <div style={{padding:'15px'}}>
            <PartDropZone
              handleDrop={ (v) => this.setState({originImage:v}) }
              style={{position:'relative'}}
            >
              {
                (this.state.uploadThumb) ?
                <div>
                  <label htmlFor="photo_file" style={{cursor:"pointer"}}>
                    <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                      <div align='center' style={{padding:'5px', position:'relative'}}>
                        <img style={{ maxWidth:'160px', maxHeight:'160px' }} src={this.state.uploadThumb} id='thumb' alt=''/>
                      </div>
                      <IconButton
                        style={{position:'absolute', right:'0px', top:'0px'}}
                        onClick={ () => this.setState({uploadThumb: null}) }
                      >
                        <ClearIcon/>
                      </IconButton>
                    </div>
                  </label>

                  <div align='center'>
                    <Fab
                      color='inherit'
                      size='small'
                      onClick={ () => this._imageRotate('l')}
                    >
                      <RotateLeftIcon/>
                    </Fab>
                    &nbsp;
                    <Fab
                      color='inherit'
                      size='small'
                      onClick={ () => this._imageRotate('r')}
                    >
                      <RotateRightIcon/>
                    </Fab>
                    &nbsp;
                    <Fab
                      color='inherit'
                      size='small'
                      onClick={ () => this.setState({dialogImageCropVisible: true}) }
                    >
                      <CropIcon/>
                    </Fab>
                  </div>

                  <DialogImageCrop
                    originImage={this.state.originImage}
                    open={this.state.dialogImageCropVisible}
                    close={ () => this.setState({dialogImageCropVisible: false}) }
                    onSubmit={ (img) => this.setState({uploadThumb:img}) }
                  />

                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{minWidth:'160px'}}
                      onClick={ () => this._uploadSubmit() }
                    >
                      <span style={{fontSize:'1.4em'}}>アップロード</span>
                    </Button>
                  </div>
                </div>
                :
                <div>
                  <div align='center' style={{padding:'5px'}}>
                    <label htmlFor="photo_file" style={{display:'block'}}>
                      <IconButton component="span">
                        <AddAPhotoIcon style={{fontSize:'4em'}}/>
                      </IconButton>
                    </label>

                    <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                      <Button variant="contained" color='primary' component="span">
                        <div>
                          <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                        </div>
                      </Button>
                    </label>
                  </div>
                </div>
              }
              <input
                type='file'
                id='photo_file'
                accept='image/*'
                onChange={ (e) => {
                  this.setState({originImage:e.target.files[0]});
                  e.target.value = null;
                }}
                style={{opacity:'0'}}
              />
            </PartDropZone>
            <div style={{padding:'5px'}} align='right'>
              <PartImageUploadHelp />
            </div>
          </div>

        </div>
			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPostAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
